import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import RatingNotification from './RatingNotification';
import { NotificationToaster } from './notification';
import '../style/notification.less';
const NotificationsList = ({ currentNotifications = [], ratingNotificaions = [], dispatch, notificationRemoveById, }) => {
    const renderNotification = (notification) => {
        if (notification.type === 'rating-up' ||
            notification.type === 'rating-down') {
            return (_jsx(RatingNotification, { dispatch: dispatch, notificationRemoveById: notificationRemoveById, notification: notification }, notification.id));
        }
        return (_jsx(NotificationToaster, { dispatch: dispatch, notificationRemoveById: notificationRemoveById, notification: notification }, notification.id));
    };
    return (_jsxs("div", Object.assign({ id: "alerts-holder" }, { children: [currentNotifications.map(renderNotification), ratingNotificaions.map(renderNotification)] })));
};
export default NotificationsList;
